import { Card, CardContent, CardHeader, Divider, Grid, Stack } from '@mui/material';
import ApartmentIcon from '@mui/icons-material/Apartment';
import { TextField } from 'customer_portal-ui-shared';

const OfficeInfo = ({ office }) => {
    return (
        <Card sx={{ width: '240px ', boxShadow: 'none' }} elavation={0}>
            {/* Header */}
            <CardHeader avatar={<ApartmentIcon />} title={office.Name} style={{ padding: 4 }} />
            {/* Content */}

            <CardContent style={{ padding: 0 }}>
                <Stack direction={'column'} spacing={1} alignItems={'stretch'} justifyContent={'flex-start'}>
                    <Divider sx={{ border: '1px solid #da1f33' }} orientation="horizontal" flexItem />
                    <TextField label="Address:" bold>
                        {`${office.AddressLine1} ${office.AddressLine2 ?? ''}`}
                    </TextField>

                    <Grid container>
                        <Grid item xs={6}>
                            <TextField label="City:" bold>
                                {office.City}
                            </TextField>
                            <TextField label="Email:" bold>
                                {office.Email === '' ? (
                                    <>
                                        <a href="mailto:contact@eagle.org">contact@eagle.org</a>
                                    </>
                                ) : (
                                    <>
                                        <a href={`mailto:${office.Email}`}>{office.Email}</a>
                                    </>
                                )}
                            </TextField>
                            <TextField label="Phone:" bold>
                                {office.Phone === '' ? '--' : office.Phone}
                            </TextField>
                        </Grid>
                        <Grid item xs={6}>
                            <TextField label="Country:" bold>
                                {office.Country}
                            </TextField>
                            <TextField label="Division:" bold>
                                {office.Division}
                            </TextField>
                            <TextField label="Fax:" bold>
                                {office.Fax === '' ? '--' : office.Fax}
                            </TextField>
                        </Grid>
                    </Grid>
                </Stack>
            </CardContent>
        </Card>
    );
};

export default OfficeInfo;
